<script>
  import options from './SourceGroupCard.options'
  export default options
</script>

<template>
  <article class="kb-source-group-card">

    <div class="kb-source-group-card__content-container">
      <div class="kb-source-group-card__icon-wrapper">
        <div class="kb-source-group-card__circle">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.1303 8.61624C18.4617 8.07477 17.693 7.67029 16.8681 7.42589C16.0432 7.1815 15.1782 7.10197 14.3226 7.19186C13.4669 7.28175 12.6374 7.53929 11.8813 7.94978C11.1251 8.36027 10.4573 8.91567 9.9158 9.58427C9.37433 10.2529 8.96985 11.0216 8.72545 11.8465C8.48106 12.6714 8.40153 13.5364 8.49142 14.392C8.58131 15.2477 8.83885 16.0772 9.24934 16.8333C9.65983 17.5895 10.2152 18.2573 10.8838 18.7988C11.7489 19.4965 12.2792 20.1348 12.2792 21.1709V21.6941H13.3257V21.1709C13.3257 19.6395 12.4675 18.729 11.5396 17.9825C10.7461 17.3396 10.146 16.4896 9.8055 15.5267C9.46504 14.5638 9.39758 13.5256 9.61057 12.5267C9.83348 11.501 10.3466 10.5611 11.0888 9.81889C11.831 9.0767 12.7709 8.56357 13.7966 8.34066C14.6094 8.15653 15.4533 8.15782 16.2655 8.34442C17.0777 8.53103 17.8375 8.89816 18.4885 9.41857C19.1294 9.93777 19.6453 10.5945 19.9979 11.3402C20.3505 12.0859 20.5308 12.9013 20.5255 13.7262C20.5201 14.551 20.3292 15.364 19.9669 16.1051C19.6047 16.8461 19.0803 17.4961 18.4327 18.0069C17.5257 18.7255 16.6885 19.5907 16.6885 21.0732V22.5H12.2827V23.5465H17.7175V21.0837C17.7175 20.0965 18.2094 19.5139 19.0641 18.8407C19.8346 18.2322 20.4584 17.4583 20.8894 16.5761C21.3204 15.6939 21.5475 14.7262 21.5538 13.7444C21.5602 12.7626 21.3457 11.7919 20.9262 10.9043C20.5067 10.0166 19.8929 9.23463 19.1303 8.61624Z" fill="#810010"/>
            <path d="M17.7139 24.2441H12.2825V25.2907H17.7139V24.2441Z" fill="#810010"/>
            <path d="M12.2825 27.0349H13.2906C13.3707 27.4292 13.5846 27.7837 13.8961 28.0383C14.2076 28.2929 14.5976 28.432 14.9999 28.432C15.4022 28.432 15.7922 28.2929 16.1037 28.0383C16.4152 27.7837 16.6292 27.4292 16.7092 27.0349H17.7174V25.9884H12.2825V27.0349Z" fill="#810010"/>
            <path d="M15 9.59302C13.8898 9.59302 12.8251 10.034 12.04 10.8191C11.255 11.6041 10.814 12.6689 10.814 13.7791V14.3023H11.8605V13.7791C11.8605 12.9464 12.1912 12.1479 12.78 11.5591C13.3688 10.9703 14.1674 10.6395 15 10.6395H15.5233V9.59302H15Z" fill="#810010"/>
            <path d="M15.5233 1.23145H14.4768V5.74191H15.5233V1.23145Z" fill="#810010"/>
            <path d="M27.3838 13.0919H22.8733V14.1384H27.3838V13.0919Z" fill="#810010"/>
            <path d="M7.12668 13.0919H2.61621V14.1384H7.12668V13.0919Z" fill="#810010"/>
            <path d="M23.3864 4.4897L20.197 7.67908L20.937 8.41907L24.1264 5.22969L23.3864 4.4897Z" fill="#810010"/>
            <path d="M9.06316 18.8121L5.87378 22.0015L6.61377 22.7415L9.80316 19.5521L9.06316 18.8121Z" fill="#810010"/>
            <path d="M20.9348 18.8119L20.1948 19.5519L23.3842 22.7413L24.1242 22.0013L20.9348 18.8119Z" fill="#810010"/>
            <path d="M6.61255 4.48852L5.87256 5.22852L9.06194 8.4179L9.80193 7.6779L6.61255 4.48852Z" fill="#810010"/>
          </svg>
        </div>
      </div>

      <div class="kb-source-group-card__content">
        <h3 class="kb-source-group-card__title">{{ title }}</h3>
        <p class="kb-source-group-card__paragraph">{{ text }}</p>
        <a class="kb-source-group-card__link" :href="linkUrl">
          <span class="kb-source-group-card__link-text">{{ linkText }}</span>

        <svg
          class="kb-source-group-card__link-icon"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M12.1674 4L15.7899 8L12.1674 12" stroke="currentColor" stroke-linejoin="round"/>
          <path d="M11.7465 8H0" stroke="currentColor"/>
        </svg>

        </a>

      </div>
    </div>

  </article>
</template>
